import { Component, Inject } from '@angular/core';
import { IConfirm } from 'src/app/interfaces/confirm';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent {

  constructor(
    public dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IConfirm) {
      //var a = this.data;

    }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
